import type { EcosystemService } from "@iec-id/shared";
import { Icon, type IconName, icons } from "@iec-id/ui";
import { serviceLogoSrc } from "./service-logo";

/**
 * Знак сервиса, в который человек входит, — рядом с заголовком «Войти в …».
 *
 * Реестр знаков и разбор, почему логотип не принимается снаружи, — в
 * `service-logo.ts`: тот же реестр рисует плитки на лендинге приглашения.
 *
 * Знака нет — показываем глиф сервиса из реестра, тот же, что витрина рисует в
 * разделе «Сервисы». Вход это не задерживает.
 */
export function ServiceBadge({ service }: { service: EcosystemService }) {
	const logo = serviceLogoSrc(service.id);
	const icon: IconName = service.icon in icons ? (service.icon as IconName) : "LayoutGrid";

	return (
		<span
			className="flex size-9 shrink-0 items-center justify-center overflow-hidden rounded-control bg-sunken"
			// Имя сервиса уже стоит в заголовке рядом, поэтому знак для
			// скринридера — украшение, а не вторая копия того же слова.
			aria-hidden="true"
		>
			{logo ? (
				// Медиа на шаг туже контейнера (r10 → r8), как в дизайн-системе.
				<img src={logo} alt="" className="size-7 rounded-field-sm" />
			) : (
				<Icon name={icon} size={20} />
			)}
		</span>
	);
}
